import createIsInvalid from './selectors/isInvalid';
import plain from './structure/plain';
export default createIsInvalid(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/isInvalid.js
// module id = YUoc
// module chunks = 1